module.exports = __webpack_public_path__ + "static/media/nobodysperfect.9c9f04e2.png";